export enum MitekCaptureStatus {
    SUCCESS = 'success',
    FAILURE = 'failure',
}

export interface MitekCaptureResult {
    response: {
        status: MitekCaptureStatus;
        imageData: string;
        mibData: unknown;
        mode: 'MANUAL' | 'AUTO';
        docType: 'CHECK_FRONT' | 'CHECK_BACK';
        ClientActivityDataLog: unknown;
        warnings: {
            status: string;
            code: string;
            key: string;
        };
        failedImage: string;
        error?: MitekSdkError;
    };
}

export interface MitekSdkError {
    cause: any;
    code: number;
    status: string;
    type: string;
}

export interface MitekSdk {
    cmd: (command: string, options?: unknown) => Promise<any>;
    on: (event: string, callback: (result: any) => void) => void;
}

export enum MitekAutoCaptureHints {
    MISNAP_HEAD_OUTSIDE = 'Slowly place Face in oval and wait',
    MISNAP_HEAD_SKEWED = 'Look Straight Ahead',
    MISNAP_AXIS_ANGLE = 'Hold Phone Upright',
    MISNAP_STAY_STILL = 'Hold Still in a well lit space',
    MISNAP_SUCCESS = 'Success',
    MITEK_ERROR_GLARE = 'Reduce Glare',
    MITEK_ERROR_FOUR_CORNER = 'Cannot see all 4 corners of the check',
    MITEK_ERROR_TOO_DARK = 'Too Dark. Use good lighting',
    MITEK_ERROR_FOCUS = 'The image is too blurry',
    CV_NO_BARCODE_FOUND = 'Scanning for barcode',
    MITEK_ERROR_TOO_FAR = 'Check Too Far',
    MITEK_ERROR_TOO_CLOSE = 'Check Too Close',
    MITEK_ERROR_NOT_CENTERED = 'Check Not Centered',
    MITEK_ERROR_MIN_PADDING = 'Slowly move farther away',
    MITEK_ERROR_HORIZONTAL_FILL = 'Slowly move closer',
    MITEK_ERROR_LOW_CONTRAST = 'Center check on a dark background',
    MITEK_ERROR_BUSY_BACKGROUND = 'Center check on a plain background',
    MITEK_ERROR_SKEW_ANGLE = 'Reduce angle',
    MITEK_ERROR_PERPENDICULAR_DOCUMENT = 'Change orientation of your check',
    AUTO_CAPTURE_HINT = 'Hold still within frame to auto-capture',
    CAMERA_PERMISSION_DENIED = 'Camera permission denied',
}

export enum MitekManualCaptureHints {
    MITEK_ERROR_FOUR_CORNER = "We can't find the 4 corners of your check.",
    MITEK_ERROR_TOO_DARK = 'There is not enough light on your check.',
    MITEK_ERROR_FOCUS = 'The image is too blurry',
    MITEK_ERROR_GLARE = 'The image has glare',
    MITEK_ERROR_MIN_PADDING = 'Move the camera farther away from your check',
    MITEK_ERROR_HORIZONTAL_FILL = 'Move the camera closer to your check',
    MITEK_ERROR_SKEW_ANGLE = 'Check is skewed.  Hold camera directly over your check',
    MITEK_ERROR_LOW_CONTRAST = 'Center check on a dark background',
    MITEK_ERROR_BUSY_BACKGROUND = 'The background is too busy, Please use a solid background',
    MITEK_ERROR_MRZ_MISSING = 'No MRZ found',
    CV_NO_BARCODE_FOUND = 'We were unable to detect the barcode from the back of your license',
    IMAGE_SMALLER_THAN_MIN_SIZE = 'The image you provided is too small',
    CORRUPT_IMAGE = 'The image you provided is unreadable',
    MISNAP_HEAD_SKEWED = 'Look Straight Ahead',
    MISNAP_HEAD_TOO_CLOSE = 'Move Farther Away',
    MISNAP_HEAD_TOO_FAR = 'Get Closer',
    NO_FACE_FOUND = 'No Face Detected',
    MITEK_ERROR_PERPENDICULAR_DOCUMENT = 'Change orientation of your check',
}

export interface MitekFeedback {
    key: keyof typeof MitekAutoCaptureHints;
    actionType: string;
}
